export const LIVE_DEMO_BUTTON_SCHEMA = {
  text: "Request Demo",
  path: "/live-demo/",
};

export const FREE_TRIAL_BUTTON_SCHEMA = {
  path: "/free-trial/",
  text: "Start Trial",
};
